import styled from 'styled-components';
// import backgroundImg from '../../../assets/PNG/landing-page-background.png';
// import backgroundImgCompress from '../../../assets/PNG/landing-page-compress.png';

// export const Main = styled.main`
//   width: 100vw;
//   height: 100vh;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background-image: url(${backgroundImg});
//   background-size: cover;
//   background-position: center;
//   position: relative;
// `;

export const Main = styled.main`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${(props) => props.bg});
  background-size: cover;
  background-position: center;
  position: relative;
  transition: background-image 0.5s ease-in-out;
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.section`
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  width: 100%;
  max-width: 1200px;
  color: #ffffff;
  padding: 60px 20px;
  text-align: left;
  align-self: flex-end;
`;

export const LeftSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
`;

export const Logo = styled.div`
  position: absolute;
  left: 10%;
  top: 4%;
  z-index: 1;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-top: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
`;
